import moment from 'moment'
export default class CustomerCommentModel {
  constructor () {
    this.id = 0
    this.user = ''
    this.content = ''
    this.type = ''
    this.isEdited = false
    this.canDelete = false
    this.canEdit = false
    this.timestamp = ''
  }
  static fromJSON (json) {
    let comment = new CustomerCommentModel()
    comment.id = json.id
    comment.user = json.user
    comment.content = json.content
    comment.type = json.type
    comment.isEdited = json.isEdited
    comment.canDelete = json.canDelete
    comment.canEdit = json.canEdit
    comment.timestamp = moment(json.timestamp).format('DD/MM/YYYY HH:mm')
    return comment
  }
}
